module.exports = __webpack_public_path__ + "media/application/images/404-img-1-ae0b2196e04e2c4d961fccc9930c1d74.png";